var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-container"},[(_vm.photo)?_c('img',{staticClass:"thumbnail",attrs:{"src":_vm.photo}}):_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.name))])])}
var staticRenderFns = []

export { render, staticRenderFns }